// This file aoids making Jest tests dependent on selectors, making them crash
import { ALL_STATUS } from 'constants/InterventionConstants';

import { isElementBefore } from 'utils/ArrayUtils';

export const isStatusBelow = (interventionStatus, referenceStatus) =>
  isElementBefore(ALL_STATUS, interventionStatus, referenceStatus);
